import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/facturacion/boletos`, options).then(response => {
    return {
      list: response.data.data,
      meta: response.data.meta
    };
  });
}

function listGlobal(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/facturacion/facturasGlobales`, options).then(response => {
    return {
      listGlobal: response.data.data,
      meta: response.data.meta
    };
  });
}

function getRegimenes() {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/facturacion/regimenesFiscales`, options)
    .then(response => {
      return response.data.data;
    });
}

function add(factura) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/facturacion/crearFactura`, factura, options).then(response => {
      return response.data.data;
    });
}

function addGlobal(factura) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/facturacion/crearFacturaGlobal`, factura, options).then(response => {
      return response.data.data;
    });
}


function getCliente(rfc) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.get(`${url}/facturacion/recuperarCliente?rfc=${rfc}`, options).then(response => {
    return response.data.data;
  });
}

function getFactura(factura) {
  const options = {
    headers: {
      'Accept': '*/*',
      "Content-Type": "application/vnd.api+json"
    },
    responseType: 'blob',
  };

  return axios.get(`${url}/facturacion/descargarFactura?boleto_id=${factura.boleto_id}&type=${factura.type}`, options)
  .then(response => {
    let fileName;
    if(factura.type === 'pdf'){
      fileName = `factura${factura.boleto_id}.pdf`;
    } 
    if(factura.type === 'xml'){
      fileName = `factura${factura.boleto_id}.xml`;
    } 
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
        window.navigator.msSaveOrOpenBlob(new Blob([response.data],
                { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
            ),
            fileName
        );
    } else {
        const url = window.URL.createObjectURL(new Blob([response.data],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    }
  });
}

function getFacturaGlobal(factura) {
  const options = {
    headers: {
      'Accept': '*/*',
      "Content-Type": "application/vnd.api+json"
    },
    responseType: 'blob',
  };

  return axios.get(`${url}/facturacion/descargarFacturaGlobal?facturapi_factura_id=${factura}`, options)
  .then(response => {
    let fileName = `factura${factura}.zip`;
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
        window.navigator.msSaveOrOpenBlob(new Blob([response.data],
                { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
            ),
            fileName
        );
    } else {
        const url = window.URL.createObjectURL(new Blob([response.data],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    }
  });
}

function getDatosCliente(rfc) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.get(`${url}/facturacion/recuperarCliente`, rfc, options).then(response => {
    return response.data.data;
  });
}

export default {
  list,
  listGlobal,
  getRegimenes,
  add,
  addGlobal,
  getCliente,
  getFactura,
  getFacturaGlobal
};
